import React from 'react';
import Chart from 'react-apexcharts';

/**
 * 
 * @param {String} height - e.g. '225px' 
 * @param {String} width - e.g. '225px' 
 * @returns 
 */
export default function RadialBarChart(_ref) {
  let {
    percentage,
    text,
    height,
    width
  } = _ref;
  const radialBarChartSetup = {
    colors: ['#00aeef'],
    chart: {
      type: 'radialBar'
      // offsetY: -40,
    },
    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 90,
        track: {
          background: '#666e7e',
          strokeWidth: '97%',
          margin: 5,
          // margin is in pixels
          shadow: {
            enabled: true,
            top: 2,
            left: 0,
            color: '#999',
            opacity: 1,
            blur: 2
          }
        },
        dataLabels: {
          name: {
            show: false
          },
          value: {
            offsetY: -2,
            fontSize: '22px',
            color: '#666E7E',
            fontFamily: 'Franklin Gothic Book'
          },
          formatter: number => window.MARKET_CONSTANTS.CURRENCY_FORMATTER.format(number)
        }
      }
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'light',
        shadeIntensity: 0.1,
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 50, 53, 91]
      }
    },
    labels: ['Average Results'],
    tooltip: {
      theme: 'dark'
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Chart, {
    options: radialBarChartSetup,
    series: percentage,
    type: "radialBar",
    height: height,
    width: width
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-primary text-center"
  }, text));
}